<template>
    <div class="backdrop" @click.self="onClose">
        <div class="log-modal">
            <div style="display:flex; flex-direction: row;justify-content:space-between;align-items:center;background-color: var(--con-main-theme-card-header-color-2);">
                <div class="report-title">Subscribers</div>
                <div class="report-export" @click="onClose">Close</div>
            </div>

            <div style="background: white; overflow-y: auto;height: 90%;">
                <table class="report-div-table" cellspacing="0" v-if="records.length > 0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col">Member #</th>
                        <th class="report-div-table-col">Name</th>
                        <th class="report-div-table-col">Email</th>
                        <th class="report-div-table-col">Plan</th>
                        <th class="report-div-table-col">Category</th>
                        <th class="report-div-table-col">Start Date</th>
                        <th class="report-div-table-col">Renews On</th>
                        <th class="report-div-table-col">Status</th>
                    </tr>

                    <tr v-for="row in records" :key="row.memberId" class="report-div-table-row">
                        <td class="report-div-table-col">{{ row.memberNumber }}</td>
                        <td class="report-div-table-col">{{ row.firstName }} {{ row.lastName }}</td>
                        <td class="report-div-table-col">{{ row.email }}</td>
                        <td class="report-div-table-col">{{ row.title }}</td>
                        <td class="report-div-table-col">{{ row.categoryName }}</td>
                        <td class="report-div-table-col">{{ row.startDateDisplay }}</td>
                        <td class="report-div-table-col">{{ row.renewsOnDisplay }}</td>
                        <td class="report-div-table-col">{{ row.statusLabel }}</td>
                    </tr>
                    <tr v-if="lastPageFull">
                        <td class="report-div-table-col" colspan="8">
                            <div @click="onLoadMoreData" class="button-link">Load more...</div>
                        </td>
                    </tr>
                </table>
                <div style="padding:15px;color:black" v-if="!fetchingData && records.length === 0">No subscribers found.</div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import apiSubscription from "@/api/apiSubscription";

const PAGE_SIZE = 50;

export default {
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);
        const records = ref([]);
        const lastPageFull = ref(false);

        const onClose = () => {
            emit("on-close");
        };

        const loadData = async (lastId) => {
            try {
                fetchingData.value = true;
                emitter.emit("server-call-start", "Loading subscribers...");

                const page = await apiSubscription.getSubscribers(lastId, PAGE_SIZE);
                page.forEach((item) => records.value.push(item));
                lastPageFull.value = page.length === PAGE_SIZE;
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading subscribers", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        const onLoadMoreData = async () => {
            const lastId = records.value[records.value.length - 1]?.memberId;
            await loadData(lastId);
        };

        onMounted(() => {
            loadData("");
        });

        return {
            fetchingData,
            records,
            lastPageFull,
            onClose,
            onLoadMoreData
        };
    }
};
</script>

<style scoped>
.log-modal {
    width: 90%;
    height: 70%;
    margin: 100px auto;
    background: white;
}
</style>
